export const primary = 'rgb(251, 133, 0)';
export const secondary = '#8b8b8b';
